import { isEmpty } from "lodash";
import type { NullableMaybe } from "types/utilities";

import * as styles from "@/features/betslip/components/parts/tokens/Tokens.module.scss";

const beautifyNumbersRegex = /(\$[0-9,]+(\.[0-9]{2})?)|([0-9]+(\.[0-9]+)?%)/g;

export const beautifyNumbers = (text: string, className?: string) =>
  text.replace(beautifyNumbersRegex, (match) => {
    return `<span class="${styles.highlight} ${className ?? ""}">${match}</span>`;
  });

export const automationTypeNames: Record<string, string> = {
  STAKE_REFUND: "Bet Reload",
  WINNINGS_BOOST: "Winnings Boost",
  PAY_AS_WINNER: "Pays As Win",
};

export const pickLegBasedCopy = (
  record: Record<string, string> | null | undefined,
  legCount: number,
): string | undefined => {
  if (!record || isEmpty(record)) return undefined;
  const match = Object.keys(record)
    .map(Number)
    .sort((a, b) => b - a)
    .find((key) => key <= legCount);
  return match === undefined ? undefined : record[String(match)];
};

export const getLegBasedBetslipInfo = (
  legCount: number,
  legBasedBetSlipInfo: NullableMaybe<Record<string, string>>,
): string => {
  const legBasedInfo = Object.values(legBasedBetSlipInfo ?? {});
  const infoIndexToGrab =
    legCount > legBasedInfo.length ? legBasedInfo.length - 1 : legCount - 1;
  return legBasedInfo[infoIndexToGrab] ?? "";
};
